import { Col, Row } from "react-bootstrap";
import styles from "./app-banner.module.scss";

interface IProps {
  content: string | React.ReactNode;
  bannerVariant: "yellow" | "lightBlue" | "lightBrown" | "lightBlueTwo";
  className?: string;
}

const AppBanner = (props: IProps) => {
  const { content, bannerVariant, className } = props;
  return (
    <Row>
      <Col
        className={`${styles.appBanner} ${styles[bannerVariant]} ${
          className ? className : "py-3"
        }`}
      >
        {content}
      </Col>
    </Row>
  );
};

export default AppBanner;
